import React from "react";
import { Text, PopOverMenu } from "components/commons";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import locale from "localization";
import moment from "moment";
import styles from "./price-movement.module.scss";
import { prettifyProductCode, prettifyProductCodeStyle } from "utils/pretty.utils";
import { CloseRounded, DoubleArrowRounded } from "@material-ui/icons";
import { formatAmount } from "utils";
import Icon, { Icons } from "components/commons/icon/icon";
import { Size } from "enums/size";

const formatDate = (dateTime) => {
  if (!dateTime) return null;
  return moment(dateTime).format("DD MMMM YYYY hh:mm A");
};

const MovementIcon = ({ amount }) => {
  const isIncrease = amount > 0;
  const isRollback = amount < 0;

  return isIncrease ? (
    <DoubleArrowRounded className={styles.iconUp} />
  ) : isRollback ? (
    <Icon icon={Icons.RightUTurn} size={Size.Large} />
  ) : (
    <CloseRounded className={styles.iconNoMovement} />
  );
};

export const mapDataToList = ({
  movement = {},
  canEdit = false,
  canDelete = false,
  onDelete,
  onEdit,
}) => {
  const {
    movementId,
    movementCode,
    effectiveAt,
    createdAt,
    createdByEmail,
    // type = "Nationwide",
    movementDetails = [],
  } = movement;

  const now = new Date();
  const effectiveDate = effectiveAt ? new Date(effectiveAt) : null;
  const isFutureMovement = effectiveDate && effectiveDate > now;

  const options = [
    ...(isFutureMovement && canEdit
      ? [
          {
            removable: true,
            content: locale.edit,
            onClick: () => onEdit(movement),
          },
        ]
      : []),
    ...(isFutureMovement && canDelete
      ? [
          {
            removable: true,
            content: locale.delete,
            onClick: () => onDelete(movement),
          },
        ]
      : []),
  ];

  const PRODUCT_ORDER = ["gas105", "gas97", "gas95", "gas91", "diesel", "kerosene", "lpg"];
  const sortedDetails = [...movementDetails].sort(
    (a, b) => PRODUCT_ORDER.indexOf(a.productCode) - PRODUCT_ORDER.indexOf(b.productCode)
  );

  const mapProducts = sortedDetails.map((product) => (
    <div
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <div
        style={{
          ...prettifyProductCodeStyle(product.productCode),
          borderRadius: "50%",
          aspectRatio: "1",
          width: "14px",
          height: "14px",
        }}
      ></div>
      <Text>{prettifyProductCode(product.productCode) || locale.NA}</Text>
    </div>
  ));

  const mapAmounts = sortedDetails.map((product) => {
    const isIncrease = product.amount > 0;
    const isRollback = product.amount < 0;
    const style = isIncrease ? styles.increase : isRollback ? styles.rollback : styles.noMovement;
    return <Text className={style}>{formatAmount(Math.abs(product.amount))}</Text>;
  });

  const mapMovements = sortedDetails.map((product) => {
    return <MovementIcon amount={product.amount} />;
  });

  return {
    priceMovementId: <Text>{movementCode || movementId || locale.NA}</Text>,
    effectiveDateTime: <Text>{formatDate(effectiveAt) || locale.NA}</Text>,
    createdAt: <Text>{formatDate(createdAt) || locale.NA}</Text>,
    processedBy: <Text>{createdByEmail || locale.NA}</Text>,
    priceMovementType: <Text>{"Nationwide" || locale.NA}</Text>,
    products: (
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>{mapProducts}</div>
    ),
    movement: (
      <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>{mapMovements}</div>
    ),
    amount: (
      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>{mapAmounts}</div>
    ),
    actions: (
      <div data-testid={`pm-list-actions-${movementCode || movementId}`}>
        {options.length > 0 ? (
          <PopOverMenu options={options}>
            <MoreVertIcon className={styles.icon} />
          </PopOverMenu>
        ) : (
          <Text>—</Text>
        )}
      </div>
    ),
  };
};

export const mapFilterToRequest = (filterState) => {
  let {
    page = 1,
    perPage = 10,
    effectiveAt,
    processedBy,
    searchType = "movementCode",
  } = filterState;

  if (processedBy?.value?.length > 0 && !processedBy?.isAll) {
    processedBy = processedBy.value.map((u) => u.value ?? u).join(",");
  } else {
    processedBy = undefined;
  }

  return {
    page,
    perPage,
    effectiveAt,
    createdBy: processedBy,
    searchType,
  };
};
